const selectors = {
  breadcrumbs: "breadcrumbs",
  productForm: "product-form",
  variantError: "variant-error",
  variantErrorCloseBtn: "variant-error-close-btn",
  ctaButton: "cta-button",
  ctaButtonMini: "cta-button-mini",
  ctaMiniAside: "cta-mini-aside",
  ctaContent: "cta-content",
  afterpay: "afterpay",
  featuredFinanceProvider: "finance-provider",
  expandButton: "expand-button",
  shippingMessage: "shipping-message",
  pdexpand: "product-description-expand",
  pdcollapse: "product-description-collapse",
  reactHookForm: "react-hook-form-input",
  featuredContent: "featured-content",
  buyBanner: "product-form-banner",
  premiumShipping: {
    title: "product-form-premium-messaging-title",
    body: "product-form-premium-messaging-body",
  },
  schematics: {
    container: "product-form-schematics-container",
    emptyState: "product-form-schematics-empty",
    imageContainer: "product-form-schematics-images",
    scrollTrack: "product-form-schematics-scroll-track",
    richTextContainer: "product-form-schematics-rich-text-container",
    specsContainer: "product-form-schematics-specs-container",
  },
  reviewsLink: "product-form-reviews-link",
};

export const analytics = {
  mainATCLocation: "product-form",
  stickyATCLocation: "mini-product-form",
};

export default selectors;
